import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { ConfigProvider } from './config/ConfigProvider'
import { ThemeProvider } from './theme/ThemeProvider'
import { ErrorBoundary } from './components/common/ErrorBoundary'
import { NotificationProvider } from './components/common/NotificationProvider'
import { CallContextProvider } from './contexts/CallContext'
import { UploadContextProvider } from './contexts/UploadContext'
import { SessionTimeoutProvider } from './contexts/SessionTimeoutContext'
import { AuthGuard } from './components/auth/AuthGuard'
import { ProtectedRoute } from './components/auth/ProtectedRoute'
import { AppShell } from './components/layout/AppShell'
import { LoginPage } from './pages/LoginPage'
import { HomePage } from './pages/HomePage'
import { UploadPage } from './pages/UploadPage'
import { ProfilePage } from './pages/ProfilePage'
import { SettingsPage } from './pages/SettingsPage'
import { PlatformAdminPage } from './pages/PlatformAdminPage'
import { CallDetailsPage } from './pages/CallDetailsPage'
import { ReportsPage } from './pages/ReportsPage'
import { DemoContactRedirect } from './components/demo/DemoContactRedirect'
import { isDemoMode } from './config'

import './App.css'

function App() {
  return (
    <ErrorBoundary>
      <ConfigProvider>
        <ThemeProvider>
          <NotificationProvider>
            <CallContextProvider>
              {/* Above the Router: uploads keep running across every route change */}
              <UploadContextProvider>
              <Router>
                <Routes>
                  {/* Login route - no auth required */}
                  <Route path="/login" element={<LoginPage />} />
                  
                  {/* Demo contact redirects */}
                  <Route 
                    path="/demo/upload" 
                    element={<DemoContactRedirect feature="upload" />} 
                  />
                  <Route 
                    path="/demo/settings" 
                    element={<DemoContactRedirect feature="settings" />} 
                  />
                  <Route 
                    path="/demo/audio" 
                    element={<DemoContactRedirect feature="audio" />} 
                  />
                  
                  {/* Protected routes */}
                  <Route path="/*" element={
                    <AuthGuard>
                      <SessionTimeoutProvider timeoutMinutes={30} warningMinutes={5}>
                        <AppShell>
                          <ErrorBoundary>
                            <Routes>
                              <Route path="/" element={
                                <ProtectedRoute>
                                  <HomePage />
                                </ProtectedRoute>
                              } />
                              <Route path="/upload" element={
                                <ProtectedRoute requireAdmin={isDemoMode}>
                                  <UploadPage />
                                </ProtectedRoute>
                              } />
                              <Route path="/profile" element={
                                <ProtectedRoute>
                                  <ProfilePage />
                                </ProtectedRoute>
                              } />
                              <Route path="/settings" element={
                                <ProtectedRoute requireAdmin={isDemoMode}>
                                  <SettingsPage />
                                </ProtectedRoute>
                              } />
                              <Route path="/admin" element={
                                <ProtectedRoute>
                                  <PlatformAdminPage />
                                </ProtectedRoute>
                              } />
                              <Route path="/call/:callId" element={
                                <ProtectedRoute>
                                  <CallDetailsPage />
                                </ProtectedRoute>
                              } />
                              <Route path="/reports" element={
                                <ProtectedRoute>
                                  <ReportsPage />
                                </ProtectedRoute>
                              } />
                            </Routes>
                          </ErrorBoundary>
                        </AppShell>
                      </SessionTimeoutProvider>
                    </AuthGuard>
                  } />
                </Routes>
              </Router>
              </UploadContextProvider>
            </CallContextProvider>
          </NotificationProvider>
        </ThemeProvider>
      </ConfigProvider>
    </ErrorBoundary>
  )
}

export default App